// src/config.js
const trim = (v) => (typeof v === 'string' ? v.trim() : '');

// ============================================================
// API CONFIGURATION
// ============================================================
const API_URL = trim(process.env.REACT_APP_API_URL) || 'https://api2.maxula.ma/api';
const SITE_URL = trim(process.env.REACT_APP_SITE_URL) || 'https://maxula.ma';

// Enlever le /api à la fin si présent pour construire l'URL des uploads
const API_BASE = API_URL.replace(/\/api\/?$/, '');

// ============================================================
// SUPPORT CONFIGURATION
// ============================================================
const SUPPORT_WHATSAPP = trim(process.env.REACT_APP_SUPPORT_WHATSAPP) || '2120606066162';
const SUPPORT_PHONE = trim(process.env.REACT_APP_SUPPORT_PHONE) || '+2120606066162';
const SUPPORT_EMAIL = trim(process.env.REACT_APP_SUPPORT_EMAIL) || 'contact@maxula.ma';
const SUPPORT_NAME = trim(process.env.REACT_APP_SUPPORT_NAME) || 'Maxula Support';
const SUPPORT_ADDRESS = trim(process.env.REACT_APP_SUPPORT_ADDRESS) || 'Avenue Hassan II, Rabat';

const normalizePhoneForWa = (phone = '') => {
  const digits = String(phone).replace(/\D/g, '');
  if (!digits) return '';
  return digits.startsWith('00') ? digits.slice(2) : digits;
};

// ============================================================
// IMAGE HELPER
// ============================================================
export const getImageUrl = (imagePath) => {
  if (!imagePath) return '/placeholder.jpg';
  
  // Si c'est déjà une URL complète
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }
  
  // Enlever les préfixes comme 'uploads/', '/uploads/', './uploads/', etc.
  const cleanPath = String(imagePath)
    .replace(/^\.?\/?uploads\//i, '')
    .replace(/^\/+/, '');
  
  // Retourner l'URL complète
  return `${API_BASE}/api/uploads/${cleanPath}`;
};

// ============================================================
// EXPORTS
// ============================================================
const config = {
  API_URL,
  API_BASE,
  SITE_URL,
  SUPPORT_NAME,
  SUPPORT_ADDRESS,
  SUPPORT_PHONE,
  SUPPORT_EMAIL,
  SUPPORT_WHATSAPP,
  SUPPORT_WHATSAPP_CLEAN: normalizePhoneForWa(SUPPORT_WHATSAPP),
  getImageUrl
};

export default config;

// Named exports pour faciliter l'import
export {
  API_URL,
  API_BASE,
  SITE_URL,
  SUPPORT_WHATSAPP,
  SUPPORT_PHONE,
  SUPPORT_EMAIL,
  SUPPORT_NAME,
  SUPPORT_ADDRESS
};